"use client"

import * as React from "react"
import { Area, AreaChart, CartesianGrid, XAxis, Bar, BarChart, YAxis, LabelList  } from "recharts"

import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "src/@/components/ui/card"
import {
  ChartContainer,
  ChartLegend,
  ChartLegendContent,
  ChartTooltip,
  ChartTooltipContent,
} from "src/@/components/ui/chart"
import EmptyContentGhost from "src/components/EmptyContentGhost"

  const chartConfig = {
    desktop: {
      label: "Desktop",
      color: "#DACFFB",
    },
  }

export function GraficoCrmOrigens({
    chartData
}) {

  return (
    <Card className="w-full">
      <CardHeader className="flex items-center gap-2 space-y-0 border-b border-gray-50 py-3 sm:flex-row">
      <h3 className="text-xl font-bold text-gray-800">Negócios por origem de vendas</h3>
      </CardHeader>
      <CardContent>
      {
          chartData?.length === 0 ? (
            <EmptyContentGhost  />
          ) : (
            <ChartContainer className="w-full h-[250px]" config={chartConfig}>
            <BarChart
              accessibilityLayer
              data={chartData}
              layout="vertical"
              margin={{
                left: 5,
                right: 30,
                top: 10,
                bottom: 10
              }}
            >
              <CartesianGrid horizontal={false} />
              <YAxis
                dataKey="nome"
                type="category"
                tickLine={false}
                tickMargin={10}
                axisLine={false}
                width={130}
                tick={{ fontSize: 12 }}
              />
              <XAxis dataKey="total" type="number" hide />
              <ChartTooltip
                cursor={false}
                content={<ChartTooltipContent indicator="line" />}
              />
              <Bar
                dataKey="total"
                layout="vertical"
                fill="var(--color-desktop)"
                radius={[0, 10, 10, 0]}
                barSize={30}
              >
                <LabelList
                  dataKey="total"
                  position="right"
                  offset={5}
                  className="fill-foreground"
                  fontSize={12}
                />
              </Bar>
            </BarChart>
          </ChartContainer>
          )}
    
      </CardContent>
    </Card>
  )
}
